import React from 'react';
import { Modal, Button, ButtonToolbar, Placeholder, IconButton } from 'rsuite';
import style from './InformationModal.module.css';
import { ExButton } from '@commons/EXComponentsLibrary';
const InformationModal = ({ open = true, setShowModal, drugmanufacturerName, productType, submit, warning }) => {
    enum WarningType {
        REPEATED_PRODUCTS = 'repeated_products',
        PREVIOUS_AGREEMENTS = 'previous_agreements',
    }
    return (
        <Modal open={open} dialogClassName={style['dialog-style']} className={style['container-modal']}>
            <Modal.Header closeButton={false}>
                <Modal.Title>
                    <div className={style['header-icon-close']}>
                        <img src="/assets/images/info2.svg" width={40} height={40} />
                        <div className={style['icon-close']} onClick={() => setShowModal(false)}>
                            <img src="/assets/images/close.svg" />
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p className={style['title']}>{`Estas por crear un acuerdo con ${drugmanufacturerName}`}.</p>
                </div>
                {
                    warning.find(w => w.name === WarningType.REPEATED_PRODUCTS) && (

                    <div className={style['container-text']}>
                        <p className={style['subtitle']}>Productos repetidos entre listas</p>
                        <span
                            className={style['label']}
                        >{`Algunos productos del listado personalizado están incluidos en ”Todos los productos ${productType}".  Aplicaremos el de mayor descuento disponible.`}</span>
                    </div>
                    )
                }

                {
                    warning.find(w => w.name === WarningType.PREVIOUS_AGREEMENTS) && (

                        <div className={style['container-text']}>
                            <p className={style['subtitle']}>Puntos de venta con acuerdos previos</p>
                            <span
                                className={style['label']}
                            >{`Algunos puntos de venta seleccionados ya tienen un acuerdo con ${drugmanufacturerName}. Si los productos se repiten entre acuerdos, se aplicará el de mayor descuento.`}</span>
                        </div>
                    )
                }
            </Modal.Body>
            <Modal.Footer>
                <ExButton onClick={submit} fullWidth>Entendido</ExButton>
            </Modal.Footer>
        </Modal>
    );
};

export default InformationModal;
